import { UseToastOptions, useToast } from "@chakra-ui/react"
import { CheckIcon } from "@pathwright/pathicons"
import { useEffect } from "react"
import { useCopyToClipboard as _useCopyToClipboard } from "react-use"

export type UseCopyToClipboardReturn = ReturnType<typeof useCopyToClipboard>

const useCopyToClipboard = (value?: string, options?: UseToastOptions) => {
  const [_, onCopy] = _useCopyToClipboard()
  const toast = useToast()

  const handleToast = (value: string, _options?: UseToastOptions) => {
    toast({
      title: "Copied to clipboard",
      description: value,
      status: "success",
      duration: 2000,
      isClosable: false,
      icon: <CheckIcon />,
      containerStyle: {
        // For long tokens (this might need to be handled via passed in props).
        overflowWrap: "anywhere"
      },
      ...options,
      ..._options
    })
  }

  // Toasts and copies the value.
  const handleCopy = (value: string, options?: UseToastOptions) => {
    onCopy(value)
    handleToast(value, options)
  }

  // Optionally copy via effect when value changes.
  useEffect(() => {
    if (value) {
      handleCopy(value)
    }
  }, [value])

  // Alternately copy on demand.
  return handleCopy
}

export default useCopyToClipboard
